// layouts
import Auth from "./layouts/Auth";
import Admin from "./layouts/Admin";

// Auth Components
import Login from "./views/Login";

// Private Components
import Dashboard from "./views/Dashboard";
import Profile from "./views/Profile";
import Roles from "./views/Roles";
import MedicalType from "./views/Forms/MedicalType/MedicalType";
import AddMedicalType from "./views/Forms/MedicalType/AddMedicalType";
import EditMedicalType from "./views/Forms/MedicalType/EditMedicalType";
import MedicalConsultations from "./views/Forms/MedicalConsultation/MedicalConsultations";
import AddMedicalConsultation from "./views/Forms/MedicalConsultation/AddMedicalConsultation";
import EditMedicalConsultation from "./views/Forms/MedicalConsultation/EditMedicalConsultation";
import AdminUser from "./views/AdminUser";
import AddAdminUser from "./views/AdminUser/AddAdminUser";
import EditAdminUser from "./views/AdminUser/EditAdminUser";

import CmsHomeSections from "./views/CmsPages/Home/index";
import AddCmsHomeSection from "./views/CmsPages/Home/AddHomeSection";
import EditCmsHomeSection from "./views/CmsPages/Home/EditHomeSection";

import CmsAboutSections from "./views/CmsPages/About/index";
import AddCmsAboutSection from "./views/CmsPages/About/AddAboutSection";
import EditCmsAboutSection from "./views/CmsPages/About/EditAboutSection";

import CmsFaqSections from "./views/CmsPages/Faqs/index";
import AddCmsFaqSection from "./views/CmsPages/Faqs/AddFaqSection";
import EditCmsFaqSection from "./views/CmsPages/Faqs/EditFaqSection";
import CmsServiceSections from "./views/CmsPages/Services/index";
import AddCmsServiceSection from "./views/CmsPages/Services/AddServiceSection";
import EditCmsServiceSection from "./views/CmsPages/Services/EditServiceSection";
import CmsPrescriptionSections from "./views/CmsPages/RefillPrescription/index";
import AddCmsPrescriptionSection from "./views/CmsPages/RefillPrescription/AddPrescriptionSection";
import EditCmsPrescriptionSection from "./views/CmsPages/RefillPrescription/EditPrescriptionSection";

import CmsLabSections from "./views/CmsPages/Laboratory/index";
import AddCmsLabSection from "./views/CmsPages/Laboratory/AddLabSection";
import EditCmsLabSection from "./views/CmsPages/Laboratory/EditLabSection";

import CmsSexualHealthSections from "./views/CmsPages/SexualHealth/index";
import AddCmsSexualHealthSection from "./views/CmsPages/SexualHealth/AddSexualHealthSection";
import EditCmsSexualHealthSection from "./views/CmsPages/SexualHealth/EditSexualHealthSection";

import CmsMentalHealthSections from "./views/CmsPages/MentalHealth/index";
import AddCmsMentalHealthSection from "./views/CmsPages/MentalHealth/AddMentalHealthSection";
import EditCmsMentalHealthSection from "./views/CmsPages/MentalHealth/EditMentalHealthSection";

import CmsPolicyPage from "./views/CmsPages/PolicyPages/index";
import AddCmsPolicyPage from "./views/CmsPages/PolicyPages/AddPolicyPage";
import EditCmsPolicyPage from "./views/CmsPages/PolicyPages/EditPolicyPage";
import SubscribePageManagement from "./views/SubscribePage/index";
import PackagePricing from "./views/PackagePricing/index";
import AddPackagePricing from "./views/PackagePricing/AddPackagePricing";
import EditPackagePricing from "./views/PackagePricing/EditPackagePricing";
import SubscriptionList from "./views/SubscriptionList/index";
import ViewSubscriptionDetails from "./views/SubscriptionList/ViewSubscriptionDetails";

import Forms from "./views/Forms/Forms";
import CreateForm from "./views/Forms/Forms/CreateForm";
import EditForm from "./views/Forms/Forms/EditForm";
import SiteSettings from "./views/SiteSettings";
import AddSiteSettings from "./views/SiteSettings/AddSiteSettings";
import EditSiteSettings from "./views/SiteSettings/EditSiteSettings";

import PartnerDiscount from "./views/PartnerDiscount";
import AddPartnerDiscount from "./views/PartnerDiscount/AddPartnerDiscount";
import EditPartnerDiscount from "./views/PartnerDiscount/EditPartnerDiscount";

import BlogCategory from "./views/blogCategory";
import AddBlogCategory from "./views/blogCategory/AddBlogCategory";
import EditBlogCategory from "./views/blogCategory/EditBlogCategory";
import Blog from "./views/blog";
import AddBlog from "./views/blog/AddBlog";
import EditBlog from "./views/blog/EditBlog";

import State from "./views/State";
import AddState from "./views/State/AddState";
import EditState from "./views/State/EditState";
import EmailTemplate from "./views/EmailTemplate";
import AddEmailTemplate from "./views/EmailTemplate/AddEmailTemplate";
import EditEmailTemplate from "./views/EmailTemplate/EditEmailTemplate";
import ReasonTemplate from "./views/ReasonTemplate";
import AddReasonTemplate from "./views/ReasonTemplate/AddReasonTemplate";
import EditReasonTemplate from "./views/ReasonTemplate/EditReasonTemplate";
import PatientUser from "./views/PatientUser";

import Consultations from "./views/Consultations/index";
import ViewConsultation from "./views/Consultations/ViewConsultation";

import PrescriptionRefill from "./views/Forms/PrescriptionFill";
import AddPrescriptionRefill from "./views/Forms/PrescriptionFill/AddPrescriptionRefill";
import EditPrescriptionRefill from "./views/Forms/PrescriptionFill/EditPrescriptionRefill";
import ConsultationPrescriptionRefill from "./views/Consultations/PrescriptionRefill";

import AddPromoCode from "./views/promoCode/AddPromoCodeForm";
import EditPromoCodeForm from "./views/promoCode/EditPromoCodeForm";
import PromoIndex from "./views/promoCode/Index";
import Logs from "./views/Logs/Index";
import AdminLogs from "./views/AdminLogs/index";

import ViewLogs from "./views/Logs/ViewLogDetails";
import PasswordManagement from "./views/PasswordManagement";
import PaidPrecriptionNotSent from "./views/Consultations/PaidPrecriptionNotSent";

import JobApplications from "./views/JobApplications";
import ViewJobApllication from "./views/JobApplications/ViewJobApllication";
import SubscriberList from "./views/SubscribersList";
import AddModal from "./views/CmsPages/AddsModal";
import AddModalSections from "./views/CmsPages/AddsModal/AddModalData";
import EditModalSections from "./views/CmsPages/AddsModal/EditModalData";


import AddAppointmentDiscount from "./views/AppointmentDiscount/AddAppointmentDiscount";
import EditAppointmentDiscount from "./views/AppointmentDiscount/EditAppointmentDiscount";
import ListingAppointmentDiscount from "./views/AppointmentDiscount/index";


import Inquiry from "./views/inquiry/index";

import ExpediteVisit from "./views/ExpediteVisit/index";
import AddExpediteVisitOption from "./views/ExpediteVisit/AddOption";
import EditExpediteVisitOption from "./views/ExpediteVisit/EditOption";

import dashboardIcon from "./assets/images/dashboard-icon.svg";
import consultationsIcon from "./assets/images/consultation-list.svg";
import prescriptionRefillIcon from "./assets/images/presciption-icon.svg";
import subscriberListIcon from "./assets/images/subscriber-list.svg";
import rolesIcon from "./assets/images/roles-icon.svg";
import adminUsersIcon from "./assets/images/admin-user-icon.svg";
import logsIcon from "./assets/images/logs-icon.svg";
import noPrescriptionIcon from "./assets/images/no-prescription-reason.svg";
import discountsIcon from "./assets/images/white-promo-discount.svg";
import stateIcon from "./assets/images/state-icon.svg";
import formsIcon from "./assets/images/forms-icon.svg";
import blogIcon from "./assets/images/blog-icon.svg";
import blogCategoryIcon from "./assets/images/blog-categories-icon.svg";
import siteSettingsIcon from "./assets/images/setting-icon.svg";
import emailTemplateIcon from "./assets/images/email-template-icon.svg";
import jobApplicationsIcon from "./assets/images/job-application-icon.svg";
import inquiryIcon from "./assets/images/inquiry-application-icon.svg";
import passwordManagementIcon from "./assets/images/password-management-icon.svg";
import patientsIcon from "./assets/images/subscriber-list.svg";
import cmsIcon from "./assets/images/cms-icon.svg";


const routes = [
  {
    path: "/",
    exact: true,
    access: true,
    name: "Admin Login",
    layout: Auth,
    component: Login,
  },
  {
    path: "/dashboard",
    permissionName: "viewDashboard",
    image: dashboardIcon,
    exact: true,
    access: true,
    name: "Dashboard",
    layout: Admin,
    component: Dashboard,
    showInSideBar: true,
  },

  {
    path: "/profile",
    permissionName: "viewProfile",
    exact: true,
    access: true,
    name: "Profile",
    layout: Admin,
    component: Profile,
  },
  //Consultations list
  {
    path: "/consultations",
    permissionName: "viewConsultations",
    image: consultationsIcon,
    exact: true,
    name: "Consultations List",
    layout: Admin,
    component: Consultations,
    showInSideBar: true,
  },
  {
    path: "/view-consultation/:id",
    permissionName: "viewConsultationsDetails",
    icon: "fa fa-user-md",
    exact: true,
    name: "View Consultations",
    layout: Admin,
    component: ViewConsultation,
  },

  //Prescription List
  {
    path: "/prescription-refill",
    permissionName: "viewPrescriptionRefill",
    image: prescriptionRefillIcon,
    exact: true,
    name: "Prescription Refill",
    layout: Admin,
    component: ConsultationPrescriptionRefill,
    showInSideBar: true,
  },
  {
    path: "/paid-consultations-prescription-not-sent",
    permissionName: "viewPaidConsultationPRescriptionNotSent",
    image: subscriberListIcon,
    exact: true,
    name: "Paid Consultation prescription Not Sent",
    layout: Admin,
    component: PaidPrecriptionNotSent,
    showInSideBar: true,
  },

  {
    path: "/view-consultation/:id",
    permissionName: "viewPaidConsultationPRescriptionNotSentDetails",
    icon: "fa fa-user-md",
    exact: true,
    name: "View Consultations",
    layout: Admin,
    component: ViewConsultation,
  },

  {
    path: "/roles",
    permissionName: "viewRole",
    image: rolesIcon,
    exact: true,
    access: true,
    name: "Roles",
    layout: Admin,
    component: Roles,
    showInSideBar: true,
  },
  {
    path: "/user/edit/:id",
    permissionName: "editUser",
    exact: true,
    access: true,
    name: "Edit User",
    layout: Admin,
    component: EditAdminUser,
  },
  {
    path: "/user/add",
    permissionName: "addUser",
    exact: true,
    access: true,
    name: "Add User",
    layout: Admin,
    component: AddAdminUser,
  },
  {
    path: "/users",
    permissionName: "viewUsers",
    image: adminUsersIcon,
    exact: true,
    access: true,
    name: "Admin Users",
    layout: Admin,
    component: AdminUser,
    showInSideBar: true,
  },


 

  {
    collapse: true,
    name: "Logs",
    state: "logs",
    image: logsIcon, 
    permissionName: "viewLogs",
    showInSideBar: true,
    submenus: [
      {
        path: "/user/logs",
        permissionName: "viewLogs",
        exact: true,
        access: true,
        name: "User Logs",
        layout: Admin,
        image: inquiryIcon,
        component: Logs,
        showInSideBar: true,
      },
      {
        path: "/admin/logs",
        permissionName: "viewLogs",
        image: subscriberListIcon, 
        exact: true,
        access: true,
        name: "Admin Logs",
        layout: Admin,
        component: AdminLogs,
        showInSideBar: true,
      },
    ],
  },





  {
    path: "/view-log/:id",
    permissionName: "viewLogs",
    icon: "fa fa-user-md",
    exact: true,
    name: "View Consultations",
    layout: Admin,
    component: ViewLogs,
  },
  {
    path: "/patients",
    permissionName: "viewPatients",
    image: patientsIcon,
    exact: true,
    access: true,
    name: "Patients Users",
    layout: Admin,
    component: PatientUser,
    showInSideBar: true,
  },
 
  {
    path: "/promo/Add",
    permissionName: "addPromoCode",
    exact: true,
    access: true,
    layout: Admin,
    component: AddPromoCode,
  },


  {
    path: "/promo/Edit/:id",
    permissionName: "editPromoCode",
    exact: true,
    access: true,
    layout: Admin,
    component: EditPromoCodeForm,
  },


  {
    path: "/appointment-discount/Add",
    permissionName: "addPromoCode",
    exact: true,
    access: true,
    layout: Admin,
    component: AddAppointmentDiscount,
  },

  {
    path: "/appointment-discount/Edit/:id",
    permissionName: "addPromoCode",
    exact: true,
    access: true,
    layout: Admin,
    component: EditAppointmentDiscount,
  },



  
  {
    path: "/partner-discount/add",
    permissionName: "addPartnerDiscount",
    exact: true,
    name: "Add Partner Discount",
    layout: Admin,
    component: AddPartnerDiscount,
  },

// {
    //   path: "/discount/appointment",
    //   permissionName: "viewMedicalType",
    //   exact: true,
    //   access: true,
    //   name: "CONSULTATION PACKAGES",
    //   layout: Admin,
    //   icon: "fa fa-calendar-check", 
    //   component: ListingAppointmentDiscount,
    //   showInSideBar: true,
    // },

{
  path: "/service-add-on",
  permissionName: "viewExpediteVisitOption",
  image: inquiryIcon,
  exact: true,
  access: true,
  name: "Service Add-ons",
  layout: Admin,
  component: ExpediteVisit,
  showInSideBar: true,
},

  // Package Pricing - Standalone menu item
  {
    path: "/package-pricing",
    permissionName: "viewPackagePricing",
    image: subscriberListIcon,
    exact: true,
    access: true,
    name: "Package Pricing",
    layout: Admin,
    component: PackagePricing,
    showInSideBar: true,
  },
  {
    path: "/package-pricing/add",
    permissionName: "addPackagePricing",
    exact: true,
    name: "Add Package Pricing",
    layout: Admin,
    component: AddPackagePricing,
  },
  {
    path: "/package-pricing/edit/:id",
    permissionName: "editPackagePricing",
    exact: true,
    name: "Edit Package Pricing",
    layout: Admin,
    component: EditPackagePricing,
  },
  // Subscription List - Standalone menu item
  {
    path: "/subscription",
    permissionName: "viewSubscriptionList",
    image: subscriberListIcon,
    exact: true,
    access: true,
    name: "Subscriptions",
    layout: Admin,
    component: SubscriptionList,
    showInSideBar: true,
  },
  {
    path: "/subscription/view/:id",
    permissionName: "viewSubscriptionList",
    exact: true,
    name: "View Subscription Details",
    layout: Admin,
    component: ViewSubscriptionDetails,
  },


{
  collapse: true,
  name: "Discounts & Offers",
  state: "discount",
  image: discountsIcon, 
  permissionName: "viewFormsManagement",
  showInSideBar: true,
  submenus: [
    {
      path: "/discount/partner-discount",
      permissionName: "viewPartnerDiscount",
      icon: "far fa-handshake",   
      exact: true,
      access: true,
      name: "Partner Discounts",
      layout: Admin,
      component: PartnerDiscount,
      showInSideBar: true,
    },
    {
      path: "/discount/promo",
      permissionName: "viewPromoCode",
      icon: "far fa-file",   
      exact: true,
      access: true,
      name: "Promotional Codes",
      layout: Admin,
      component: PromoIndex,
      showInSideBar: true,
    },
  ],
},


////////////////////////////////////////////////////////
  {
    path: "/partner-discount/edit/:id",
    permissionName: "editPartnerDiscount",
    exact: true,
    name: "Edit Partner Discount",
    layout: Admin,
    component: EditPartnerDiscount,
  },

  {
    path: "/service-add-on/option/add",
    permissionName: "addExpediteVisitOption",
    exact: true,
    access: true,
    name: "Add Service Add-ons ",
    layout: Admin,
    component: AddExpediteVisitOption,
  },
  {
    path: "/service-add-on/option/edit/:id",
    permissionName: "editExpediteVisitOption",
    exact: true,
    access: true,
    name: "Edit Service Add-ons",
    layout: Admin,
    component: EditExpediteVisitOption,
  },


   {
    path: "/reason-Template",
    permissionName: "viewReasonTemplate",
    image: noPrescriptionIcon,
    exact: true,
    name: "No Prescription Reasons",
    layout: Admin,
    component: ReasonTemplate,
    showInSideBar: true,
  },
  {
    path: "/reason-template/add",
    permissionName: "addReasonTemplate",   
    exact: true,
    name: "Add No Prescription Reasons",
    layout: Admin,
    component: AddReasonTemplate,
  },
  {
    path: "/reason-template/edit/:id",
    permissionName: "editReasonTemplate",
    exact: true,
    name: "Edit No Prescription Reasons",
    layout: Admin,
    component: EditReasonTemplate,
  },


  {
    path: "/email-template",
    permissionName: "viewEmailTemplate",
    image: emailTemplateIcon,
    exact: true,
    name: "Email Template",
    layout: Admin,
    component: EmailTemplate,
    showInSideBar: true,
  },
  {
    path: "/email-template/add",
    permissionName: "addEmailTemplate",
    exact: true,
    name: "Add Email Template",
    layout: Admin,
    component: AddEmailTemplate,
  },
  {
    path: "/email-template/edit/:id",
    permissionName: "editEmailTemplate",
    exact: true,
    name: "Edit Email Template",
    layout: Admin,
    component: EditEmailTemplate,
  },

  {
    path: "/password-management",
    permissionName: "viewPassword",
    image: passwordManagementIcon,
    exact: true,
    name: "Password Management ",
    layout: Admin,
    component: PasswordManagement,
    showInSideBar: true,
  },

  // JOb Applications
  {
    path: "/job-applications",
    permissionName: "viewJobApplication",
    image: jobApplicationsIcon,
    exact: true,
    access: true,
    name: "Job Applications",
    layout: Admin,
    component: JobApplications,
    showInSideBar: true,
  },
  // Subscriber List
  {
    path: "/subscription-list",
    permissionName: "viewEmailSubscriber",
    image: subscriberListIcon,
    exact: true,
    name: "Email Subscribers List",
    layout: Admin,
    component: SubscriberList,
    showInSideBar: true,
  },
  {
    path: "/view-job-application/:id",
    permissionName: "viewJobApplicationDetails",
    icon: "fa fa-user-md",
    exact: true,
    name: "View Job Applications",
    layout: Admin,
    component: ViewJobApllication,
  },
//inquiry application
  {
    path: "/inquiry",
    permissionName: "viewinqueryData",
    image: inquiryIcon,
    exact: true,
    access: true,
    name: "Inquiry Applications",
    layout: Admin,
    component: Inquiry,
    showInSideBar: true,
  },

  // site settings
  {
    path: "/site-settings",
    permissionName: "viewSetting",
    image: siteSettingsIcon,
    exact: true,
    name: "Site Settings",
    layout: Admin,
    component: SiteSettings,
    showInSideBar: true,
  },
  {
    path: "/site-settings/add",
    permissionName: "addSetting",
    exact: true,
    name: "Add Site Setting",
    layout: Admin,
    component: AddSiteSettings,
  },
  {
    path: "/site-settings/edit/:id",
    permissionName: "editSetting",
    exact: true,
    name: "Edit Site Setting",
    layout: Admin,
    component: EditSiteSettings,
  },

  // Blogs

  {
    path: "/blog",
    permissionName: "viewBlog",
    image: blogIcon,
    exact: true,
    name: "Blogs",
    layout: Admin,
    component: Blog,
    showInSideBar: true,
  },
  {
    path: "/blog/add",
    permissionName: "addBlog",
    exact: true,
    access: true,
    name: "Add Blog",
    layout: Admin,
    component: AddBlog,
  },
  {
    path: "/blog/edit/:id",
    permissionName: "editBlog",
    exact: true,
    access: true,
    name: "Edit Blog",
    layout: Admin,
    component: EditBlog,
  },


  

  //Blog Category
  {
    path: "/blog-category",
    permissionName: "viewBlogCategories",
    image: blogCategoryIcon,
    exact: true,
    name: "Blog Categories",
    layout: Admin,
    component: BlogCategory,
    showInSideBar: true,
  },
  {
    path: "/blog-category/add",
    permissionName: "addBlogCategories",
    exact: true,
    name: "Add Blog Category",
    layout: Admin,
    component: AddBlogCategory,
  },
  {
    path: "/blog-category/edit/:id",
    permissionName: "editBlogCategories",
    exact: true,
    name: "Edit Blog Category",
    layout: Admin,
    component: EditBlogCategory,
  },

  //States
  {
    path: "/state",
    permissionName: "viewState",
    image: stateIcon,
    exact: true,
    name: "States",
    layout: Admin,
    component: State,
    showInSideBar: true,
  },
  {
    path: "/state/add",
    permissionName: "addState",
    exact: true,
    name: "Add State",
    layout: Admin,
    component: AddState,
  },
  {
    path: "/state/edit/:id",
    permissionName: "editState",
    exact: true,
    name: "Edit State",
    layout: Admin,
    component: EditState,
  },
  
  {
    collapse: true,
    name: "Forms",
    state: "forms",
    image: formsIcon,
    permissionName: "viewFormsManagement",
    showInSideBar: true,
    submenus: [
      {
        path: "/forms/medical-type",
        permissionName: "viewMedicalType",
        exact: true,
        access: true,
        name: "Medical Type",
        layout: Admin,
        image: patientsIcon,
        component: MedicalType,
        showInSideBar: true,
      },
      {
        path: "/forms/medical-consultations",
        permissionName: "viewMedicalConsultation",
        exact: true,
        access: true,
        name: "Medical Consultations",
        layout: Admin,
        image: consultationsIcon,
        component: MedicalConsultations,
        showInSideBar: true,
      },
      {
        path: "/forms/forms",
        permissionName: "viewForms",
        exact: true,
        access: true,
        name: "Forms",
        image: formsIcon,
        layout: Admin,
        component: Forms,
        showInSideBar: true,
      },
      {
        path: "/forms/prescription-refill",
        permissionName: "viewPrescriptionRefillType",
        exact: true,
        access: true,
        name: "Prescription Refill",
        image: prescriptionRefillIcon,
        layout: Admin,
        component: PrescriptionRefill,
        showInSideBar: true,
      },
    ],
  },
  {
    collapse: true,
    name: "CMS",
    state: "cms",
    permissionName: "viewCmsManagement",
    showInSideBar: true,
    image: cmsIcon,
    submenus: [
      {
        path: "/cms/home",
        permissionName: "viewCmsHomeSection",
        exact: true,
        access: true,
        name: "Home",
        layout: Admin,
        icon: "far fa-building",
        component: CmsHomeSections,
        showInSideBar: true,
      },
      {
        path: "/cms/adds",
        // permissionName: "viewCmsHomeSection",

        permissionName: "viewModalData",
        exact: true,
        access: true,
        name: "Adds Modal",
        layout: Admin,
        icon: "far fa-bell",
        component: AddModal,
        showInSideBar: true,
      },
      {
        path: "/cms/about",
        permissionName: "viewCmsAboutSection",
        exact: true,
        access: true,
        name: "About",
        layout: Admin,
        icon: "far fa-file",
        component: CmsAboutSections,
        showInSideBar: true,
      },
      {
        path: "/cms/faqs",
        permissionName: "viewCmsFaqSection",
        exact: true,
        access: true,
        name: "FAQs",
        layout: Admin,
        icon: "far fa-question-circle",
        component: CmsFaqSections,
        showInSideBar: true,
      },
      {
        path: "/cms/services",
        permissionName: "viewCmsServiceSection",
        exact: true,
        access: true,
        name: "Services",
        layout: Admin,
        icon: "far fa-folder",
        component: CmsServiceSections,
        showInSideBar: true,
      },
      {
        path: "/cms/prescriptions",
        permissionName: "viewCmsPrescriptionSection",
        exact: true,
        access: true,
        name: "Refill Prescription",
        layout: Admin,
        icon: "far fa-square",
        component: CmsPrescriptionSections,
        showInSideBar: true,
      },
      {
        path: "/cms/labs",
        permissionName: "viewCmsLabSection",
        exact: true,
        access: true,
        name: "Laboratory",
        layout: Admin,
        icon: "far fa-clipboard",
        component: CmsLabSections,
        showInSideBar: true,
      },
      {
        path: "/cms/sexual-health",
        permissionName: "viewCmsSexualHealthSection",
        exact: true,
        access: true,
        name: "Sexual Health",
        layout: Admin,
        icon: "far fa-heart",
        component: CmsSexualHealthSections,
        showInSideBar: true,
      },
      {
        path: "/cms/mental-health",
        permissionName: "viewCmsMentalHealthSection",
        exact: true,
        access: true,
        name: "Mental Health",
        layout: Admin,
        icon: "far fa-bookmark",
        component: CmsMentalHealthSections,
        showInSideBar: true,
      },

      {
        path: "/cms/policy-pages",
        permissionName: "viewCmsPolicyPage",
        exact: true,
        access: true,
        name: "Policy & Condition Page",
        layout: Admin,
        icon: "far fa-file",
        component: CmsPolicyPage,
        showInSideBar: true,
      },
      {
        path: "/cms/subscribe-page",
        permissionName: "viewSubscribePage",
        exact: true,
        access: true,
        name: "Subscribe Page",
        layout: Admin,
        icon: "far fa-file",
        component: SubscribePageManagement,
        showInSideBar: true,
      },
    ],
  },



  {
    path: "/cms/adds/modal",
    permissionName: "addMedicalType",
    exact: true,
    name: "Add Modal Data",
    layout: Admin,
    component: AddModalSections,
  },
  {
    path: "/cms/modal/edit/:id",
    permissionName: "editMedicalType",
    exact: true,
    name: "Edit add modal data",
    layout: Admin,
    component: EditModalSections,
  },

  {
    path: "/forms/medical-type/add",
    permissionName: "addMedicalType",
    exact: true,
    name: "Add Medical Type",
    layout: Admin,
    component: AddMedicalType,
  },
  {
    path: "/forms/medical-type/edit/:id",
    permissionName: "editMedicalType",
    exact: true,
    name: "Edit Medical Type",
    layout: Admin,
    component: EditMedicalType,
  },
  {
    path: "/forms/medical-consultations/add",
    permissionName: "addMedicalConsultation",
    exact: true,
    name: "Add Medical Consultation",
    layout: Admin,
    component: AddMedicalConsultation,
  },
  {
    path: "/forms/medical-consultations/edit/:id",
    permissionName: "editMedicalConsultation",
    exact: true,
    name: "Edit Medical Type",
    layout: Admin,
    component: EditMedicalConsultation,
  },
  {
    path: "/forms/prescription-refill/add",
    permissionName: "addMedicalConsultation",
    exact: true,
    name: "Add Prescription Refill",
    layout: Admin,
    component: AddPrescriptionRefill,
  },
  {
    path: "/forms/prescription-refill/edit/:id",
    permissionName: "editMedicalConsultation",
    exact: true,
    name: "Edit Prescription Refill",
    layout: Admin,
    component: EditPrescriptionRefill,
  },

  {
    path: "/forms/create",
    permissionName: "addForms",
    exact: true,
    access: true,
    name: "Create Form",
    layout: Admin,
    component: CreateForm,
  },
  {
    path: "/forms/edit/:id",
    permissionName: "editForms",
    exact: true,
    access: true,
    name: "Edit Form",
    layout: Admin,
    component: EditForm,
  },

  {
    path: "/cms/home/add",
    permissionName: "addCmsHomeSection",
    exact: true,
    name: "Add Home",
    layout: Admin,
    component: AddCmsHomeSection,
  },
  {
    path: "/cms/home/edit/:id",
    permissionName: "editCmsHomeSection",
    exact: true,
    name: "Edit Home",
    layout: Admin,
    component: EditCmsHomeSection,
  },

  {
    path: "/cms/about/add",
    permissionName: "addCmsAboutSection",
    exact: true,
    name: "Add About",
    layout: Admin,
    component: AddCmsAboutSection,
  },
  {
    path: "/cms/about/edit/:id",
    permissionName: "editCmsAboutSection",
    exact: true,
    name: "Edit About",
    layout: Admin,
    component: EditCmsAboutSection,
  },

  {
    path: "/cms/faqs/add",
    permissionName: "addCmsFaqSection",
    exact: true,
    name: "Add Faq",
    layout: Admin,
    component: AddCmsFaqSection,
  },
  {
    path: "/cms/faqs/edit/:id",
    permissionName: "editCmsFaqSection",
    exact: true,
    name: "Edit Faq",
    layout: Admin,
    component: EditCmsFaqSection,
  },

  {
    path: "/cms/service/add",
    permissionName: "addCmsServiceSection",
    exact: true,
    name: "Add Service",
    layout: Admin,
    component: AddCmsServiceSection,
  },
  {
    path: "/cms/service/edit/:id",
    permissionName: "editCmsServiceSection",
    exact: true,
    name: "Edit Serivce",
    layout: Admin,
    component: EditCmsServiceSection,
  },

  {
    path: "/cms/prescription/add",
    permissionName: "addCmsPrescriptionSection",
    exact: true,
    name: "Add Prescription",
    layout: Admin,
    component: AddCmsPrescriptionSection,
  },
  {
    path: "/cms/prescription/edit/:id",
    permissionName: "editCmsPrescriptionSection",
    exact: true,
    name: "Edit Prescription",
    layout: Admin,
    component: EditCmsPrescriptionSection,
  },

  {
    path: "/cms/lab/add",
    permissionName: "addCmsLabSection",
    exact: true,
    name: "Add Laboratory",
    layout: Admin,
    component: AddCmsLabSection,
  },
  {
    path: "/cms/lab/edit/:id",
    permissionName: "addCmsLabSection",
    exact: true,
    name: "Edit Laboratory",
    layout: Admin,
    component: EditCmsLabSection,
  },

  {
    path: "/cms/sexual-health/add",
    permissionName: "addCmsSexualHealthSection",
    exact: true,
    name: "Add Sexual Health",
    layout: Admin,
    component: AddCmsSexualHealthSection,
  },
  {
    path: "/cms/sexual-health/edit/:id",
    permissionName: "editCmsSexualHealthSection",
    exact: true,
    name: "Edit Sexual Health",
    layout: Admin,
    component: EditCmsSexualHealthSection,
  },

  {
    path: "/cms/mental-health/add",
    permissionName: "addCmsMentalHealthSection",
    exact: true,
    name: "Add Mental Health",
    layout: Admin,
    component: AddCmsMentalHealthSection,
  },
  {
    path: "/cms/mental-health/edit/:id",
    permissionName: "editCmsMentalHealthSection",
    exact: true,
    name: "Edit Mental Health",
    layout: Admin,
    component: EditCmsMentalHealthSection,
  },

  {
    path: "/cms/policy-page/add",
    permissionName: "addCmsPolicyPage",
    exact: true,
    name: "Add Policy",
    layout: Admin,
    component: AddCmsPolicyPage,
  },
  {
    path: "/cms/policy-page/edit/:id",
    permissionName: "editCmsPolicyPage",
    exact: true,
    name: "Edit Policy",
    layout: Admin,
    component: EditCmsPolicyPage,
  },

];

export default routes;
